import React, { FC, PropsWithChildren } from 'react'
import { Col, Collapse, Row } from 'antd'
import { XOR } from 'Helpers'
import { UISizes } from 'LibNeo/constants/UIConstants'
import { colorStatus, Heading, HeadingType, StatusComponent } from 'LibNeo'
import { Callback } from 'Src/types/utilTypes'
import { AccordionCollapse, Description, TitleWrapper, ToggleIcon } from './styled'

const { Panel } = Collapse
export type AccordionStatus = { color?: colorStatus } & XOR<
	{ text: string; icon?: string },
	{ text?: string; icon: string }
>

type AccordionProps = {
	id: number | string
	titleText: string
	isButtonSpaceBetween?: boolean
	titleSize?: UISizes.BIG | UISizes.NORMAL
	iconsBlock?: JSX.Element
	buttonsBlock?: JSX.Element
	status?: AccordionStatus
	onClick?: Callback
	description?: string | JSX.Element
	panelForceRender?: boolean
	className?: string
} & XOR<
	{
		isOpened?: boolean
		isHideToggleIcon?: boolean
	},
	{
		noExpand?: boolean
		isOpened?: boolean
	}
>

export const AccordionComponent: FC<PropsWithChildren<AccordionProps>> = ({
	id,
	isOpened = false,
	children,
	titleText,
	isButtonSpaceBetween = false,
	titleSize = UISizes.NORMAL,
	iconsBlock = null,
	buttonsBlock = null,
	status = null,
	onClick,
	description,
	noExpand,
	isHideToggleIcon = noExpand,
	panelForceRender,
	className,
}) => {
	const title = {
		[UISizes.BIG]: HeadingType.h5,
		[UISizes.NORMAL]: HeadingType.h6,
	}

	const activeKeyProps = noExpand ? { activeKey: id } : { defaultActiveKey: isOpened ? id : null }
	return (
		<AccordionCollapse {...activeKeyProps} noExpanding={noExpand} className={className}>
			<Panel
				key={id}
				showArrow={false}
				header={
					<>
						<Row
							type="flex"
							justify={isButtonSpaceBetween ? 'start' : 'space-between'}
							align="middle"
							gutter={[16, 0]}
							onClick={onClick}
						>
							<Col>
								<Row type="flex" gutter={[16, 0]} align="middle">
									<Col>
										<TitleWrapper>
											<Heading type={title[titleSize]}>{titleText}</Heading>
											{!isHideToggleIcon && <ToggleIcon name="chevron-right" size={titleSize} />}
										</TitleWrapper>
									</Col>
									{Boolean(status) && (
										<StatusComponent
											title={status.text}
											iconName={status.icon}
											color={status?.color ?? 'gold'}
											isForm
										/>
									)}
									{iconsBlock && <Col>{iconsBlock}</Col>}
								</Row>
							</Col>
							<Col>
								<Row type="flex">
									{buttonsBlock && (
										<Col
											onClick={(e) => {
												e.stopPropagation()
											}}
										>
											{buttonsBlock}
										</Col>
									)}
								</Row>
							</Col>
						</Row>
						{Boolean(description) && (
							<Row>
								<Col
									span={24}
									onClick={(e) => {
										e.stopPropagation()
									}}
								>
									<Description>{description}</Description>
								</Col>
							</Row>
						)}
					</>
				}
				forceRender={panelForceRender}
			>
				{children}
			</Panel>
		</AccordionCollapse>
	)
}
